import script from "./ToastNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastNotification.vue?vue&type=script&setup=true&lang=js"

import "./ToastNotification.vue?vue&type=style&index=0&id=36dfc654&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36dfc654"]])

export default __exports__